import { BEAUTY_SALONS_REFERENCE_DEMO } from "./beauty/salons/reference/manifest";
import { GASTRONOMY_GENERIC_DRAFT_DEMO } from "./gastronomy/generic-draft/manifest";
import { GASTRONOMY_REFERENCE_RESTAURANT_DEMO } from "./gastronomy/reference-restaurant/manifest";
import { HOSPITALITY_REFERENCE_PLACEHOLDER } from "./hospitality/reference/manifest";
import { RENOVATION_MAISON_MOREL_REFERENCE_DEMO } from "./home-services/renovation/maison-morel/manifest";
import type { DemoManifest, DemoType } from "./types";

export const DEMO_CATALOG: readonly DemoManifest[] = Object.freeze([
  BEAUTY_SALONS_REFERENCE_DEMO,
  GASTRONOMY_GENERIC_DRAFT_DEMO,
  GASTRONOMY_REFERENCE_RESTAURANT_DEMO,
  HOSPITALITY_REFERENCE_PLACEHOLDER,
  RENOVATION_MAISON_MOREL_REFERENCE_DEMO,
]);

function uniqueSorted(values: readonly string[]): readonly string[] {
  return Object.freeze(Array.from(new Set(values)).sort((left, right) => left.localeCompare(right)));
}

/**
 * Compatibility helper for the original Demos Workspace.
 * Prefer demosForIndustry for new code.
 */
export function demosForVertical(vertical: string): readonly DemoManifest[] {
  return DEMO_CATALOG.filter((demo) => demo.vertical === vertical);
}

export function demosForIndustry(industryKey: string): readonly DemoManifest[] {
  return DEMO_CATALOG.filter((demo) => demo.industryKey === industryKey);
}

export function demosForNiche(nicheKey: string): readonly DemoManifest[] {
  return DEMO_CATALOG.filter((demo) => demo.nicheKey === nicheKey);
}

export function demosForSolution(solutionKey: string): readonly DemoManifest[] {
  return DEMO_CATALOG.filter((demo) => demo.solutionKey === solutionKey);
}

export function demosForType(demoType: DemoType): readonly DemoManifest[] {
  return DEMO_CATALOG.filter((demo) => demo.demoType === demoType);
}

export const DEMO_VERTICALS = uniqueSorted(DEMO_CATALOG.map((demo) => demo.vertical));

export const DEMO_INDUSTRIES = Object.freeze(
  Array.from(
    new Map(
      DEMO_CATALOG.map((demo) => [
        demo.industryKey,
        Object.freeze({ key: demo.industryKey, label: demo.industryLabel }),
      ]),
    ).values(),
  ).sort((left, right) => left.label.localeCompare(right.label)),
);

export const DEMO_NICHES = Object.freeze(
  Array.from(
    new Map(
      DEMO_CATALOG.map((demo) => [
        demo.nicheKey,
        Object.freeze({ key: demo.nicheKey, label: demo.nicheLabel }),
      ]),
    ).values(),
  ).sort((left, right) => left.label.localeCompare(right.label)),
);

export const DEMO_SOLUTIONS = Object.freeze(
  Array.from(
    new Map(
      DEMO_CATALOG.map((demo) => [
        demo.solutionKey,
        Object.freeze({ key: demo.solutionKey, label: demo.solutionLabel }),
      ]),
    ).values(),
  ).sort((left, right) => left.label.localeCompare(right.label)),
);

export const DEMO_TYPES: readonly DemoType[] = Object.freeze([
  "reference",
  "prospect",
  "module",
  "legacy",
]);
